import React from 'react';

const AfterPublishModal = (props) => {
    const { afterPublishModal, setAfterPublishModal } = props;
    return (
        <div className="AfterPublishModal PublishModal" style={{ display: afterPublishModal ? 'flex' : 'none' }}>
            <div className="AfterPublishModal-header">
                <h4 className="AfterPublishModal" style={{ color: '#000' }}>Your iFloorPlan is Published</h4>
            </div>
            <div className="AfterPublishModal-body">
                <h5 className="AfterPublishModal" style={{ lineHeight: 'inherit' }}>Any changes you have made<br />
                    have been saved</h5>
            </div>
            <div className={props.type_action === "edit" && props.ifloorplanNowState.first_published_datetime ? "updateModal-footer" : "PublishModal-footer"}>
                <span className="AfterPublishModal-close">
                    <a onClick={() => setAfterPublishModal(false)}
                        style={{
                            borderRadius: '3px',
                            padding: '5px 53px',
                            backgroundColor: '#eee',
                            border: 'solid 0.3px #afafaf',
                            color: '#6e6c6c',
                            fontSize: 'medium'
                        }}><span>Continue editing</span></a>
                </span>
            </div>
        </div>
    )
}

export default AfterPublishModal;
